/**
 * @module api-scm:warehouse/warehouse
 */
import service from '@/service'

/**
 * 列表查询
 * @param {{
 * keywords:string,
 * limit:number,
 * page:number,
 * sort:string,
 * productCode:string,
 * productName:string,
 * date:Array<string>
 * }} params
 */
export function getList(data) {
  return service['api-scm']({
    url: '/scm/warehouse/warehouseMaterialApply/get/getList',
    method: 'post',
    data
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 *
 * @param {(string|number)} code
 * @description 树形表格下拉
 */
export function getListDown(code) {
  return service['api-scm']({
    url: '/scm/warehouse/warehouseMaterialApply/get/getListDownNew',
    method: 'get',
    params: { code },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
/**
 *
 * @param {(string|number)} code
 * @description 下推
 */
export function pushListDown(code) {
  return service['api-scm']({
    url: '/scm/warehouse/warehouseMaterialApply/get/getListDown',
    method: 'get',
    params: { code },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 *新增
 * @param {object} data
 */
export function create(data) {
  return service['api-scm']({
    url: '/scm/warehouse/warehouseMaterialApply/save',
    method: 'post',
    data
  })
}

/**
 * 详情
 * @param {number} id
 * @returns {any}
 */
export function info(id) {
  return service['api-scm']({
    url: '/scm/warehouse/warehouseMaterialApply/info',
    method: 'get',
    params: { id }
  })
}

/**
 *
 * @param {{string}} id
 * @returns
 * @description  待办详情 (无需权限)
 */
export function todoInfo(id) {
  return service['api-scm']({
    url: '/public/activiti/warehouseMaterialApply/info',
    method: 'get',
    params: { id },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 *修改
 * @param {object} data
 */
export function update(data) {
  return service['api-scm']({
    url: '/scm/warehouse/warehouseMaterialApply/update',
    method: 'post',
    data
  })
}
/**
 * @param {object} data
 */
export function submit(ids) {
  return service['api-scm']({
    url: '/scm/warehouse/warehouseMaterialApply/submit',
    method: 'post',
    data: { ids },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
/**
 * 审核驳回
 * @param {object} data
 */
export function reject(data) {
  return service['api-scm']({
    url: '/public/activiti/warehouseMaterialApply/reject',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
/**
 * @param {string} ids
 * @description 作废
 */
export function invalid(ids) {
  return service['api-scm']({
    url: '/scm/warehouse/warehouseMaterialApply/cancellation',
    method: 'post',
    data: { ids },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
/**
 * @param {string} ids
 * @description 结束流程（结束审核流）
 */
export function withdraw(ids) {
  return service['api-scm']({
    url: '/scm/warehouse/warehouseMaterialApply/withdraw',
    method: 'post',
    data: { ids },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
/**
 * @param {{ids:string}} params
 * @description 删除  params
 */
export function remove(params) {
  return service['api-scm']({
    url: '/scm/warehouse/warehouseMaterialApply/delete',
    method: 'delete',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @description 导出原料辅料申请
 */
export function exportData(data) {
  return service['api-scm']({
    url: '/scm/warehouse/warehouseMaterialApply/dataExport',
    method: 'post',
    data,
    responseType: 'blob', // 文件流接收类型声明转成 blob
    saveAs: true // 文件流是否通过浏览器下载
  })
}

/**
 * @description 下推
 */
export function pushDown(data) {
  return service['api-scm']({
    url: '/scm/warehouse/warehouseMaterialApply/pushDown',
    method: 'post',
    data
  })
}

/**
 * @description 撤销
 */
export function reviewRevocation(data) {
  return service['api-scm']({
    url: '/scm/warehouse/warehouseMaterialApply/withdraw',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @description 明细下推
 */
export function pushDetailDown(data) {
  return service['api-scm']({
    url: '/scm/warehouse/warehouseMaterialApply/pushDetailDown',
    method: 'post',
    data
  })
}
/**
 * @description 整单下推
 */
export function pushIntactDown(data) {
  return service['api-scm']({
    url: '/scm/warehouse/warehouseMaterialApply/pushIntactDown',
    method: 'post',
    data
  })
}

/**
 * @param {String} purchaseCodeList
 * @description 整单关闭
 */
export function orderWholeClose(data) {
  return service['api-scm']({
    url: '/scm/warehouse/warehouseMaterialApply/orderWholeClose',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @param {String} purchaseCodeList
 * @description 整单反关闭
 */
export function orderWholeReClose(params) {
  return service['api-scm']({
    url: '/scm/warehouse/warehouseMaterialApply/orderWholeReClose',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
